import React from "react";
import Row from "./Row";

const TableData = ({
  data,
  headers,
  rowPress,
  actions,
  draggable,
  children,
  collapsing,
}) => {
  return (
    <>
      {data &&
        data.map((item, i) => (
          <React.Fragment key={item._id || i}>
            <Row
              keyRowIndex={i}
              totalRows={data.length}
              item={item}
              draggable={draggable}
              headers={headers}
              rowPress={rowPress}
              actions={actions}
              count={i + 1}
            />
            {collapsing === item && children}
          </React.Fragment>
        ))}
    </>
  );
};

export default TableData;
